<template>
  <div class="box">
    <img src="../../../static/images/dz.png" />

    <div class="dznum">{{ likeCount }}</div>

    <div class="praise_bubble" id="praise_bubble">
      <!-- <div
        id="bubble"
        class="bubble"
        style="z-index: 9"
        @click="addPraise"
      ></div> -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'likeBtn',

  props: {
    likeCount: {
      type: String,
      require: true
    }
  },

  data() {
    return {
      praiseBubble: null
    }
  },

  mounted() {},

  methods: {
    addPraise: _.throttle(
      function () {
        const that = this
        if (!this.praiseBubble) {
          that.praiseBubble = document.getElementById('praise_bubble')
        }
        const b = Math.floor(Math.random() * 3) + 1
        const bl = Math.floor(Math.random() * 11) + 1 // bl1~bl11

        const d = document.createElement('div')
        d.className = `bubble b${b} bl${bl}`
        d.dataset.t = String(Date.now())
        that.praiseBubble.appendChild(d)
        setTimeout(() => {
          that.praiseBubble.removeChild(d)
        }, 4000)
      },
      300,
      { trailing: false }
    )
  }
}
</script>

<style lang="less" scoped>
@import url(../../../static/css/dz.css);
/deep/ .praise_bubble {
  position: absolute;
  bottom: 40px;
  left: -30px;
}
.box {
  cursor: pointer;
  z-index: 9;
  img {
    width: 40px;
    height: 40px;
  }
  .dznum {
    position: absolute;
    bottom: 4px;
    text-align: center;
    width: 40px;
    left: 0;
    background: hsla(0, 0%, 100%, 0.5);
    border-radius: 10px;
    font-size: 12px;
    color: #000;
  }
}
</style>
